import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslocoService } from '@ngneat/transloco';
import { cloneDeep } from 'lodash-es';
import { SqlTableComparison } from '../database-table-view.component';

@Component({
    selector: 'single-database-table-view',
    templateUrl: 'single-database-table-view.component.html',
    styles: [
        /* language=SCSS */
        `
            ::ng-deep .columnsTooltip {
                background-color: black !important;
                color: white !important;
                font-size: 15px;
              }
        `
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SingleDatabaseTableViewComponent implements OnInit{

    @Input() table: SqlTableComparison;
    @Input() compare: boolean;

    compareMode: boolean = false;
    drawTable: SqlTableComparison;

    constructor(
        private snackbar: MatSnackBar,
        private translocoService: TranslocoService,
    ) { }

    ngOnInit(): void {
        this.compareMode = this.compare;
        this.drawTable = cloneDeep(this.table);
        this.drawTable.columns.sort((a, b) => a.name <= b.name ? -1 : 1);
    }

    toggleAndCopy($event: MouseEvent, item: any) {
        this.toggle($event, item);
        this.copyToClipboard();
    }

    toggle($event: MouseEvent, item: any) {
        $event.stopPropagation();
        item.show = !item.show;
    }

    toggleAllOut() {
        //this.elementTypeTooltip.show = false;
        //this.uriNameTooltip.show = false;
        //this.linkTypeTooltip.show = false;
    }

    copyToClipboard() {
        this.snackbar.open(this.translocoService.translate('copiedToClipboard'), this.translocoService.translate('accept'), { duration: 5000 });
    }

}

